<template>
  <div class="plan-discount-label">
    <div v-if="data?.properties?.badge_promotion" class="label-promotion">
      АКЦИЯ %
    </div>

    <div
      v-else-if="data?.properties?.has_badge"
      class="label-promotion label-promotion--simple"
    >
      АКЦИЯ
    </div>

    <div v-else-if="data?.discount" class="label-discount">
      {{ data?.discount }}%
      <span>скидка</span>
    </div>

    <div
      v-else-if="data?.properties?.reverse_discount_percent"
      class="label-discount"
    >
      {{ data?.properties?.reverse_discount_percent }}%
      <span>скидка</span>
    </div>

    <div v-else-if="data?.properties?.badge_parking" class="label-parking">
      <Icon icon="parking-present" />
    </div>

    <div v-else-if="data?.properties?.badge_storeroom" class="label-parking">
      <Icon icon="storeroom-present" />
    </div>

    <div
      v-else-if="data?.properties?.give_meters"
      class="label-discount-meters"
    >
      {{ getDiscountArea(data) }} м²
      <span>в подарок!</span>
    </div>
  </div>
</template>

<script>

export default {
  name: "PlanDiscountLabel",
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  setup() {
    const getDiscountArea = (data) => {
      return Math.trunc(data.layout.area * (data.discount / 100) * 10) / 10;
    };
  }
};
</script>

<style lang="scss" scoped>
.plan-discount-label {
  width: 55px;
  height: 55px;
  display: flex;
  overflow: hidden;

  .label-promotion,
  .label-discount,
  .label-parking {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 5px;
    line-height: 1;

    border-radius: 50%;
    color: #FFFFFF;
    background-color: #FF0020;
  }

  .label-promotion {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: uppercase;

    &--simple {
      font-size: 11px;
    }
  }

  .label-discount {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0;
    span {
      font-size: 9px;
      font-weight: 400;
      letter-spacing: -2%;
      text-transform: uppercase;
      display: block;
    }
  }

  .label-discount-meters {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: #FF0020;
    color: #FFFFFF;
    border-radius: 14px;

    span {
      font-size: 9px;
      letter-spacing: -0.02em;
    }
  }
}
</style>
